import { EllipsedText, FlexColumn, FlexRow, useMoment } from '@gorila-shared-ui/components';
import { BlockProps } from 'baseui/block';
import { ParagraphXSmall } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { NotificationCore } from '../../types/notification';

type Props = {
  notification: NotificationCore;
};

function NotificationBody({ notification }: Readonly<Props>) {
  const { css, theme, concatenateClasses } = useStyles();
  const { formatDateFromTs } = useMoment();

  const centeredBetween = css({
    alignItems: 'center',
    justifyContent: 'space-between',
  });
  const textSharedProps: BlockProps = {
    margin: 0,
    color: theme.colors.contentSecondary,
  };
  const vehicleTextSharedProps: BlockProps = {
    margin: 0,
    color: theme.colors.contentTertiary,
  };
  const equalFlex = css({ flex: 1 });

  return (
    <FlexColumn gap={0}>
      <FlexRow classNames={centeredBetween}>
        <ParagraphXSmall {...textSharedProps}>
          <EllipsedText
            inline
            breakAll={false}
          >
            {notification.label ?? ''}
          </EllipsedText>
        </ParagraphXSmall>
        <ParagraphXSmall {...textSharedProps}>
          {notification.created && formatDateFromTs(notification.created)}
        </ParagraphXSmall>
      </FlexRow>
      <FlexRow classNames={centeredBetween}>
        <ParagraphXSmall
          {...vehicleTextSharedProps}
          className={concatenateClasses(equalFlex, css({ textAlign: 'start' }))}
        >
          {notification.brand}
        </ParagraphXSmall>
        <ParagraphXSmall
          {...vehicleTextSharedProps}
          className={concatenateClasses(equalFlex, css({ textAlign: 'center' }))}
        >
          {notification.subBrand}
        </ParagraphXSmall>
        <ParagraphXSmall
          {...vehicleTextSharedProps}
          className={concatenateClasses(equalFlex, css({ textAlign: 'end' }))}
        >
          {notification.licensePlate ?? ''}
        </ParagraphXSmall>
      </FlexRow>
    </FlexColumn>
  );
}

export default memo(NotificationBody);
